import React from "react";
import { node } from "prop-types";

import SocketProvider from "./socket/SocketContext";
import AuthInitializer from "./auth/AuthInitializer";
import AuthProvider from "./auth/auth.context";
import SettingProvider from "./data/SettingContext";
import DataProvider from "./data/DataContext";
import CartProvider from "./data/CartContext";
import ListProvider from "./list/list.context";
import LoadingProvider from "./loading/LoadingContext";
import ThemeProvider from "./data/ThemeContext";
import CountProvider from "./data/CountContext";
import VisitorContextProvider from "./data/VisitorContext";

import { I18nextProvider } from 'react-i18next'
import i18n from './../i18n/i18n'

const ContextProvider = ({ children }) => {
    return (
        <I18nextProvider i18n={i18n}>
            <LoadingProvider>
                <AuthProvider>
                    <AuthInitializer>
                        <VisitorContextProvider>
                            <DataProvider>
                                <ListProvider>
                                    <SettingProvider>
                                        <CountProvider>
                                            <CartProvider>
                                                <ThemeProvider>
                                                    <SocketProvider>
                                                        {children}
                                                    </SocketProvider>
                                                </ThemeProvider>
                                            </CartProvider>
                                        </CountProvider>
                                    </SettingProvider>
                                </ListProvider>
                            </DataProvider>
                        </VisitorContextProvider>
                    </AuthInitializer>
                </AuthProvider>
            </LoadingProvider>
        </I18nextProvider>
    );
};

ContextProvider.propTypes = {
    children: node.isRequired
};

export default ContextProvider;